'use client';

import TurnDeviceSVG from '@public/icons/turn-device.svg';
import classNames from 'classnames';
import { HTMLAttributes, useEffect, useMemo, useState } from 'react';
import { tp } from '@/shared/lib/typograf';

interface Props extends HTMLAttributes<HTMLElement> {}

const text = tp('Пожалуйста, поверните ваше устройство в вертикальное положение');

const TurnDeviceMessage = (props: Props) => {
    const mobileLandscapeMq = useMemo(
        () => (typeof window !== 'undefined' ? matchMedia('(max-width: 900px) and (orientation: landscape)') : null),
        [],
    );
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onMediaQueryChange = () => {
            if (mobileLandscapeMq) {
                setVisible(mobileLandscapeMq.matches);
            }
        };

        onMediaQueryChange();
        mobileLandscapeMq?.addEventListener('change', onMediaQueryChange);

        return () => {
            mobileLandscapeMq?.removeEventListener('change', onMediaQueryChange);
        };
    }, [mobileLandscapeMq]);

    return (
        <div {...props} className={classNames('turn-device-message', props.className)} hidden={!visible}>
            <div className="turn-device-message__icon">
                <TurnDeviceSVG />
            </div>
            <div className="text-xl turn-device-message__text">{text}</div>
        </div>
    );
};

export default TurnDeviceMessage;
